import React from 'react';
import { motion } from 'framer-motion';
export function LoopMapSection() {
  const cards = [{
    id: '01',
    title: 'Body Alarm',
    description: 'Your physiology spikes: hot, tense, alert, restless.'
  }, {
    id: '02',
    title: 'Thought Spiral',
    description: 'Your mind grabs: money, work, health, relationships, regret, tomorrow.'
  }, {
    id: '03',
    title: 'Bed Fear',
    description: 'Your bed becomes a test you keep failing—so you start monitoring yourself, pressuring yourself, performing.'
  }];
  return <section className="py-16 md:py-32 px-5 md:px-6 relative overflow-hidden" data-id="element-122">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-123">
        <div className="absolute inset-0 bg-[#0a0e1a]/90 z-10" data-id="element-124" />
        <img src="https://cdn.magicpatterns.com/uploads/cMgCUcsbWUNDjKss7SMwaf/3AM_2_MOCKUP.png" alt="Bed spotlight background" className="w-full h-full object-cover opacity-40" data-id="element-125" />
      </div>

      <div className="max-w-4xl mx-auto relative z-20" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-10 md:mb-16" data-id="element-127">
          <h2 className="text-2xl md:text-5xl font-playfair text-[#f5f0e8] mb-4 md:mb-6" data-id="element-128">
            Introducing: The Loop Map
          </h2>
          <p className="text-base md:text-xl text-[#e8e0d4] max-w-2xl mx-auto leading-relaxed" data-id="element-129">
            The 3AM Loop Breaker is built on a simple truth:
            <br data-id="element-130" />
            What feels like "one insomnia problem" is usually{' '}
            <strong className="text-[#c9a96e]" data-id="element-131">
              three different problems
            </strong>{' '}
            wearing the same mask.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-132">
          {cards.map((card, index) => <motion.div key={card.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.3,
          duration: 0.8
        }} className="bg-[#111827]/60 backdrop-blur-md border border-[#ffffff]/5 p-5 md:p-8 rounded-xl hover:border-[#c9a96e]/30 transition-colors duration-500 group" data-id="element-133">
              <span className="text-4xl md:text-6xl font-playfair text-[#ffffff]/5 group-hover:text-[#c9a96e]/10 transition-colors duration-500 block mb-2 md:mb-4" data-id="element-134">
                {card.id}
              </span>
              <h3 className="text-lg md:text-xl font-bold text-[#f5f0e8] mb-2 md:mb-4 group-hover:text-[#c9a96e] transition-colors duration-300" data-id="element-135">
                {card.title}
              </h3>
              <p className="text-sm md:text-base text-[#e8e0d4] leading-relaxed" data-id="element-136">
                {card.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 1,
        duration: 1
      }} className="mt-10 md:mt-16 text-center" data-id="element-137">
          <p className="text-base md:text-lg text-[#8b8178] italic" data-id="element-138">
            Most people keep throwing one tool at all three. That's why it feels
            random.
            <br data-id="element-139" />
            This guide gives you the Loop Map—so you can identify what's
            actually happening and use the matching move.
          </p>
        </motion.div>
      </div>
    </section>;
}